import { experimental_extendTheme as extendTheme } from "@mui/material";
import typography from "./typography";
import colorSchemes from "./colorSchemes";
import components from "./components";

const theme = extendTheme({
  cssVarPrefix: "winvest",
  typography,
  colorSchemes,
  components,
  hoverable: {
    "&:hover": {
      cursor: "pointer",
      border: "2px solid #000",
      boxShadow: "0px 4px 0px 0px #757575",
    },
  },
});

export { weights as fontWeights } from "./typography";

export default theme;
